import { fork, take } from 'redux-saga/effects';
import { loadFromLocalStorage } from './handlers/loadFromLocalStorage';
import { saveToLocalStorage } from './handlers/saveToLocalStorage';
import { watchAndSaveToLocalStorage } from './handlers/watchAndSaveToLocalStorage';
import { LOCAL_STORAGE_SAVE, LocalStorageSave } from './actions';

export default function* localStorageSaga(): Generator {
  // Запуск воркера для сохранения данных
  yield fork(watchAndSaveToLocalStorage);

  // Запуск воркера для загрузки данных
  yield fork(function* (): Generator {
    yield loadFromLocalStorage();
  });

  // Запуск воркера для обработки действий сохранения
  yield fork(function* (): Generator {
    while (true) {
      const action = yield take(LOCAL_STORAGE_SAVE) as ReturnType<typeof LocalStorageSave>;
      yield saveToLocalStorage(action as ReturnType<typeof LocalStorageSave>);
    }
  });
}

export * from './actions';
